import React, { Component } from "react";
import { connect } from "react-redux";
import Info from "../shared/Info";
import {
  addFeedbacks,
  getMemberFeks,
  selectWorkflow,
  clearMemberFek,

} from "../../../state/ducks/workflow/index";
import $ from "jquery";
import { getKvkkService } from "../../../services/common.service";
import KvkkModal from "../shared/KvkkModal";

function oneriFormKontrol() {
  var konu = $("#konu").val();
  var mesaj = $("#mesaj").val();
  var selectTalep = $("#talep option:selected").text();
  var selectUyeNo = $("#uyeNo option:selected").text();
  var durum = 1;

  // anlık kontrol için - checkbox
  document.querySelector('#onaychecked').addEventListener("change", function () {
    if ($("#onaychecked").is(':checked')) {
      $(".t-tooltip").css({ "display": "none" });
    } else {
      $(".t-tooltip").css({ "display": "flex" });
    }
  });

  // checkbox kontrol
  if ($("#onaychecked").is(':checked')) {
    $(".t-tooltip").css({ "display": "none" });
  } else {
    durum = 0; // Seçili değil
    $(".t-tooltip").css({ "display": "flex" });
  }
  // konu boş mu kontrol
  if (selectTalep == "Seçiniz") {
    durum = 0; // Konu Boş
    $("#talep").parent().addClass("t-error");
    $("#talep").next().html("<i class='t-icon-error text-danger'></i>");
    $("#talep_hatamesaj").html("Başvuru nedeni boş bırakılamaz");
  } else {
    $("#talep").parent().removeClass("t-error");
    $("#talep").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#talep_hatamesaj").html("");
  }
  debugger;
  if (selectUyeNo == "Seçiniz" && (selectTalep == "Araç Rehin Fek" || selectTalep == "Konut İpotek Fek")) {
    durum = 0; // Konu Boş
    $("#uyeNo").parent().addClass("t-error");
    $("#uyeNo").next().html("<i class='t-icon-error text-danger'></i>");
    $("#talep_hatamesaj").html("Uyelik bilgisi boş bırakılamaz");
  } else {
    $("#uyeNo").parent().removeClass("t-error");
    $("#uyeNo").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#talep_hatamesaj").html("");
  }
  // konu boş mu kontrol
  if (konu == "") {
    durum = 0; // Konu Boş
    $("#konu").parent().addClass("t-error");
    $("#konu").next().html("<i class='t-icon-error text-danger'></i>");
    $("#konu_hatamesaj").html("Konu alanı boş bırakılamaz");
  } else {
    $("#konu").parent().removeClass("t-error");
    $("#konu").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#konu_hatamesaj").html("");
  }
  // Açıklama boş mu kontrol
  if (mesaj == "") {
    durum = 0; // Mesaj Boş
    $("#mesaj").parent().addClass("t-error");
    $("#mesaj").next().html("<i class='t-icon-error text-danger'></i>");
    $("#mesaj_hatamesaj").html("Mesaj alanı boş bırakılamaz");
  } else {
    $("#mesaj").parent().removeClass("t-error");
    $("#mesaj").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#mesaj_hatamesaj").html("");
  };
  return durum;
}

export class SubmitDemand extends Component {
  state = {
    subject: "",
    description: "",
    reason: "0",
    memberNo: "0",
    memberFekList: [],
    isSubjectReadonly: true,
    kvkkMetni: "",
    isKvkkModalOpen: false,
  };
  componentDidMount() {
    this.setState({ memberNo: "0" });
    this.props.clearMemberFek();
  }
  onSubmit = (e) => {
    e.preventDefault();

    if (oneriFormKontrol() == 0) {
      return false;
    }
    this.props.addFeedbacks(
      this.state.subject,
      this.state.description,
      this.state.reason,
      this.state.memberNo,

    );
  };
componentDidUpdate(prevProps) {
  // MemberFek kontrolün (bunu değiştirmedik)
  if (
    (this.state.reason === "5" || this.state.reason === "6") &&
    !this.props.isLoading
  ) {
    if (this.props.memberFekList.length === 0 && !this.props.isLoading) {
      $("#uyeNo").parent().addClass("t-error");
      $("#uyeNo").next().html("<i class='t-icon-error text-danger'></i>");
      $("#talep_hatamesaj").html(
        "Üyelik bulunamadı. Araç Rehin Fek ya da Konut İpotek Fek talebi açılamaz."
      );
    } else {
      $("#uyeNo").parent().removeClass("t-error");
      $("#uyeNo").next().html(
        "<i class='t-icon-check_circle_outline text-success'></i>"
      );
      $("#talep_hatamesaj").html("");
    }
  }

  // ❗ Form resetleme sadece error yeni geldiyse yapılmalı
  if (
    this.props.workflow?.error &&
    prevProps.workflow?.error !== this.props.workflow.error
  ) {
    this.setState({
      subject: "",
      description: "",
      reason: "0",
      memberNo: "0",
      isSubjectReadonly: true
    });
    this.props.clearMemberFek();
    $("#talep").val("0");
    $("#konu").val("");
    $("#mesaj").val("");
    $("#uyeNo").val("");
    $("#onaychecked").prop("checked", false);
    $("#talep_hatamesaj").html("");
  }
}

 getKvkk = () => {
     getKvkkService().then(
       (response) => {
         console.log(response);
         this.setState({
           isKvkkModalOpen: true,
           kvkkMetni: response.data?.kvkkMetni ?? "", // KVKK metnini de set et
         });
       },
       (error) => {
         console.error("KVKK metni alınamadı", error);
       }
     );
   };
 
   closeKvkkModal = () => {
     this.setState({ isKvkkModalOpen: false });
   };

  render() {
    const { workflow } = this.props;
    if (workflow?.addedFeedback) {
      return (
        <Info
          header={"Talebiniz alınmıştır."}
          body={
            "Talebiniz ile ilgili gelişmeleri 'Talep Takibi' menüsünden takip edebilirsiniz."
          }
        ></Info>
      );
    } else {
      return (
        <div className="container-fluid">
          {/* yesil Alan*/}
          <div className="row" style={{ padding: "3%" }}>
            <div className="col-12">
              {/* KUTU 1 */}
              <div className="row no-gutters t-kutu t-yesilCizgi">
                <div
                  className="col bosluk backright"
                  style={{
                    backgroundImage: 'url("/assets/img/backgrounds/back_right_yesil.jpg")'
                  }}
                >
                  {/* içerikler */}
                  {/* Başlık */}
                  <div className="row no-gutters pb-4">
                    <div clss="col-auto">
                      <i className="t-icon-bubble1 icon" />
                    </div>
                    <div className="col d-flex flex-column justify-content-center">
                      <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                        Öneri ve İstekleriniz
                      </div>
                      <span className="altBaslik">Öneri ve İstek Bildirimi</span>
                    </div>
                  </div>
                  <div className="row no-gutters">
                    <div className="col-12 pb-1">
                      <span className="t-icInputTitle pl-3">Başvuru Nedeniniz</span>
                    </div>
                    {/* üye numaranız*/}
                    <div className="col-12">
                      <div className="t-icInput">
                        <div>
                          <i className="t-icon-lock1" />
                        </div>
                        <select
                          className="custom-select"
                          id="talep"
                          onChange={(e) => {
                            const value = e.target.value;
                            const selectTalep = $("#talep option:selected").text();
                            this.setState({ reason: value });

                            if (value === "5" || value === "6") {
                              this.setState({ memberNo: "0", subject: selectTalep,isSubjectReadonly: true });
                              this.props.getMemberFeks(value);
                            } else {
                              $("#uyeNo").parent().removeClass("t-error");
                              $("#uyeNo").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
                              $("#talep_hatamesaj").html("");
                              this.setState({ memberNo: "0", subject: "", isSubjectReadonly: false });
                              this.props.clearMemberFek();
                            }
                          }}
                        >
                          <option value="0">Seçiniz</option>
                          <option value="1">Şikayet</option>
                          <option value="2">Talep</option>
                          <option value="3">Öneri</option>
                          <option value="4">Memnuniyet</option>
                          <option value="5">Araç Rehin Fek</option>
                          <option value="6">Konut İpotek Fek</option>
                        </select>
                        <div />
                      </div>
                    </div>
                    {/* Hata mesajının geleceği alan*/}
                    <div
                      className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                      id="talep_hatamesaj"
                    />
                    {(this.props.memberFekList && this.props.memberFekList.length > 0) && (
                      <div className="col-12 pb-1">
                        <span className="t-icInputTitle pl-3">Üyelik Bilgisi</span>
                        <div className="t-icInput">
                          <div>
                            <i className="t-icon-user" />
                          </div>
                          <select
                            className="custom-select"
                            id="uyeNo"
                            onChange={(e) => this.setState({ memberNo: e.target.value })}
                          >
                            <option value="">Seçiniz</option>
                            {this.props.memberFekList.map((item, index) => (
                              <option key={item.id} value={item.id}>
                                {item.adi}
                              </option>
                            ))}
                          </select>
                          <div />
                        </div>
                      </div>

                    )}
    
                    {/* Konu */}
                    <div className="col-12 pb-1">
                      <span className="t-icInputTitle pl-3">Konu</span>
                    </div>
                    <div className="col-12">
                      <div className="t-icInput">
                        <div>
                          <i className="t-icon-pen1" />
                        </div>
                        <input
                          type="text"
                          id="konu"
                          name="konu"
                          placeholder="Konu Başlığınızı Yazınız"
                          required
                          maxLength="200"
                          value={this.state.subject}
                          readOnly={this.state.isSubjectReadonly}
                          onChange={(e) => {
                            this.setState({ subject: e.target.value });
                          }}
                        />
                        <div />
                      </div>
                    </div>
                    {/* KONU Hata mesajının geleceği alan*/}
                    <div
                      className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                      id="konu_hatamesaj"
                    />
                    {/* Açıklama*/}
                    <div className="col-12 pb-1">
                      <span className="t-icInputTitle pl-3">Açıklama</span>
                    </div>
                    <div className="col-12">
                      <div className="t-icInput">
                        <div>
                          <i className="t-icon-bubble1" />
                        </div>
                        <textarea
                          className="form-control"
                          id="mesaj"
                          name="mesaj"
                          rows="3"
                          required
                          maxLength="1000"
                          value={this.state.description}
                          onChange={(e) => {
                            this.setState({ description: e.target.value });
                          }}
                          placeholder="Mesajınızı Yazınız"

                        />
                        <div />
                      </div>
                    </div>
                    {/* Mesaj Hata mesajının geleceği alan*/}
                    <div
                      className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                      id="mesaj_hatamesaj"
                    />
                    {/* checkbox */}
                    <div className="col-12 d-flex align-items-center pb-3">
                      <input
                        type="checkbox"
                        className="t-kvkkcheckbox"
                        value=""
                        id="onaychecked"
                      />
                      <span
                        className="t-icAciklamaYazi"
                        style={{ paddingLeft: 10, position: "relative" }}
                      >
                        <a id="kvkk-onayla" href="#kvkk-onayla" onClick={this.getKvkk}>KVKK Taahhütnamesi</a>'ni <strong>ONAYLIYORUM</strong>
                    
                        <div className="t-tooltip">
                          <i className="t-icon-arrow-left pr-1" />
                          Devam Etmek İçin Onaylamalısınız
                        </div>
                      </span>
                    </div>
                    {/* Button */}
                    <div className="col-12 d-flex justify-content-center pb-3">
                      <button className="t-icButtonYesil" onClick={this.onSubmit}>
                        <span>Mesajımı Gönder</span>
                        <i className="t-icon-arrow-right2" />
                      </button>
                    </div>
                  </div>
                  {/* içerikler BİTTİ */}
                </div>
                <div className="col-auto renk" />
              </div>
              {/* KUTU 1 BİTTİ */}
            </div>
          </div>
          {/* Duyurlar Baslık*/}
          {/* duyrular Bitti*/}
          <div className="row" style={{ height: 30 }} />

            
        <KvkkModal
          isOpen={this.state.isKvkkModalOpen}
          kvkkMetni={this.state.kvkkMetni}
          onClose={this.closeKvkkModal}
        />

        </div>

      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    workflow: selectWorkflow(state),
    memberFekList: state.workflow.memberFek || [],
    isLoading: state.workflow.isLoading || false 
  };
};

const mapDispatchToProps = (dispatch) => ({
  addFeedbacks: (subject, description, reason, memberNo) =>
    dispatch(addFeedbacks(subject, description, reason, memberNo)),
  getMemberFeks: (orgTuru) =>
    dispatch(getMemberFeks(orgTuru)),
  clearMemberFek: () => dispatch(clearMemberFek())
});

export default connect(mapStateToProps, mapDispatchToProps)(SubmitDemand);
